import React from 'react';
import { Box, Breadcrumbs, Divider, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useL2DTheme } from '@europrocurement/flexy-components';
import { Tiers, TiersCommercial } from '@europrocurement/l2d-modules/providers/TiersProvider';
import { CommercialSection } from '../CommercialSection';
import { LifecycleSection } from '../LifecycleSection';
import { DomainesSection } from '../DomainesSection';

const PRESCRIBERS_LIST_PATH = '/prescripteurs/liste';

type PrescriberHeroProps = {
    prescripteur: Tiers;
    offerName?: string;
    commerciaux?: TiersCommercial[];
};

const PrescriberHero: React.FunctionComponent<PrescriberHeroProps> = function ({
    prescripteur,
    offerName,
    commerciaux,
}) {
    const { palette } = useL2DTheme();
    const mainCommercial = commerciaux?.[0];

    const addressInfo = [
        prescripteur.adresse?.fullAddress,
        prescripteur.siren ? `SIREN ${prescripteur.siren}` : null,
    ]
        .filter(Boolean)
        .join(' · ');

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 1,
                    px: 1,
                }}
            >
                <Breadcrumbs separator="/">
                    <Link
                        component={RouterLink}
                        to={PRESCRIBERS_LIST_PATH}
                        underline="hover"
                        color="text.secondary"
                        variant="body2"
                    >
                        Prescripteurs
                    </Link>
                    <Typography
                        variant="body2"
                        color="text.primary"
                        fontWeight={600}
                    >
                        {prescripteur.raisonSociale}
                    </Typography>
                </Breadcrumbs>
                {addressInfo && (
                    <Typography
                        variant="body2"
                        color="text.secondary"
                    >
                        {addressInfo}
                    </Typography>
                )}
            </Box>
            <Box
                sx={{
                    p: 3,
                    backgroundColor: palette.background.paper,
                    borderRadius: 2,
                    border: `1px solid ${palette.divider}`,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 3,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        gap: 3,
                        flexWrap: 'wrap',
                        alignItems: 'flex-start',
                    }}
                >
                    {mainCommercial && (
                        <>
                            <Box sx={{ width: '25%' }}>
                                <CommercialSection commercial={mainCommercial} />
                            </Box>
                            <Divider
                                orientation="vertical"
                                flexItem
                            />
                        </>
                    )}
                    <LifecycleSection offerName={offerName} />
                </Box>

                <Divider />

                <DomainesSection prescripteur={prescripteur} />
            </Box>
        </>
    );
};

export default PrescriberHero;
